import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetTariffById = function () {
    return useApiCall(function (signal, id) { return api.tariff.apiTariffDataGetIdGet(id, { signal: signal }); }, null, true, []);
};
